export const usersKeys = {
  all: ["users"] as const,
  users: ["users", "list"] as const,
  usersCount: ["users", "count"] as const,
  currentUser: ["users", "current"] as const,
  user: (oktaId: string) => ["users", "user", oktaId] as const,
};
